import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Sidebar from "./components/sidebar/Sidebar";
import Navbar from "./components/navbar/Navbar";
import Login from "./components/login/Login";
import "./App.css";
import Dashboard from "./components/pages/Dashboard";
import Brand from "./components/pages/Masters/Brand";
import Model from "./components/pages/Masters/Models";
import Staff from "./components/pages/Masters/Staffs";
import Roles from "./components/pages/Roles";
import Charges from "./components/pages/Masters/Charges";
import GeneralBill from "./components/pages/Bill/GeneralBill";
import Invoice_Bill from "./components/pages/Invoice_Bill";
import Add_GeneralBill from "./components/pages/Bill/Add_GeneralBill";
import Update_GeneralBill from "./components/pages/Bill/Update_GeneralBill";
import Report from "./components/pages/Report";
import Add_GST from "./components/pages/Bill/Add_GST";
import GST_bill from "./components/pages/Bill/GST_bill";
import Update_GSTbill from "./components/pages/Bill/Update_GSTbill";
import Dummy from "./components/pages/Dummy";
import Add_MotoBill from "./components/pages/Bill/Add_MotoBill";
import Motorola_Bill from "./components/pages/Bill/Motorola_Bill";
import Update_MotoBill from "./components/pages/Bill/Update_MotoBill";

function App() {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  // eslint-disable-next-line
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    setIsLoggedIn(!!token);
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
      if (window.innerWidth > 1024) {
        setSidebarOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const toggleSidebar = () => {
    if (!isMobile) {
      setSidebarCollapsed(!sidebarCollapsed);
    }
  };

  const toggleMobileSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/" element={<Login />} />
        <Route path="/invoice-bill/:bill_no" element={<Invoice_Bill />} />

        {/* Protected routes (with Sidebar + Navbar) */}
        <Route
          path="/*"
          element={
            <MainApp
              sidebarCollapsed={sidebarCollapsed}
              sidebarOpen={sidebarOpen}
              isMobile={isMobile}
              toggleSidebar={toggleSidebar}
              toggleMobileSidebar={toggleMobileSidebar}
              closeSidebar={closeSidebar}
            />
          }
        />
      </Routes>
    </Router>
  );
}

function MainApp({
  sidebarCollapsed,
  sidebarOpen,
  isMobile,
  toggleSidebar,
  toggleMobileSidebar,
  closeSidebar,
}) {
  return (
    <div className="App">
      <Sidebar
        collapsed={isMobile ? false : sidebarCollapsed}
        toggleSidebar={toggleSidebar}
        isOpen={sidebarOpen}
        closeSidebar={closeSidebar}
        isMobile={isMobile}
      />
      <div
        className={`main-content ${
          !isMobile && sidebarCollapsed ? "sidebar-collapsed" : ""
        }`}
        onClick={() => isMobile && sidebarOpen && closeSidebar()}
      >
        <Navbar
          collapsed={sidebarCollapsed}
          toggleMobileSidebar={toggleMobileSidebar}
          isMobile={isMobile}
        />
        <div className="content-wrapper">
          <Routes>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/masters/brand" element={<Brand />} />
            <Route path="/masters/models" element={<Model />} />
            <Route path="/masters/staffs" element={<Staff />} />
            <Route
              path="/users"
              element={<Roles toggleSidebar={toggleSidebar} />}
            />
            <Route path="/masters/charges" element={<Charges />} />
            <Route
              path="/bill/general"
              element={<GeneralBill toggleSidebar={toggleSidebar} />}
            />

            <Route
              path="/bill/gstbill"
              element={<GST_bill toggleSidebar={toggleSidebar} />}
            />

            <Route
              path="/bill/motorola"
              element={<Motorola_Bill toggleSidebar={toggleSidebar} />}
            />

            <Route
              path="/bill/Add-gst"
              element={<Add_GST toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/bill/update-gst/:id"
              element={<Update_GSTbill toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/bill/general/add-general-bill"
              element={<Add_GeneralBill toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/bill/general/update-general-bill/:id"
              element={<Update_GeneralBill toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/bill/motorola/add-motorola-bill"
              element={<Add_MotoBill toggleSidebar={toggleSidebar} />}
            />
            <Route
              path="/bill/motorola/update-motorola-bill/:id"
              element={<Update_MotoBill toggleSidebar={toggleSidebar} />}
            />
            <Route path="/reports" element={<Report />} />

            <Route path="/dummy" element={<Dummy />} />
          </Routes>
        </div>
      </div>
    </div>
  );
}

export default App;
